import { Response } from "../Model"
import client from "./client"

interface PostalCodeData {
    id: number;
    postalCode: string;
    street: string;
    block: string;
    buildingName: string;
}

const getPostalCode = (code: string) => {
    return client.get<Response<PostalCodeData[]>>(
        `postal-code/${code}`,
    )
}

export default getPostalCode
